export function ProgressData() {
    return [
        {
            "tunnelNumber": "51090b2cd9694751b6f247406948fb75",
            "completionRatio": 8,
            "tunnelName": "辽宁五台隧道"
        },
        {
            "tunnelNumber": "5335a31819534a88a1af30e0e534d374",
            "completionRatio": 47.61905,
            "tunnelName": "辽宁长白隧道"
        },
        {
            "tunnelNumber": "a76473521a9f48c589990234d6ecf6ca",
            "completionRatio": 53.846157,
            "tunnelName": "陕西大兴隧道"
        },
        {
            "tunnelNumber": "d6d0d0065a694974af31ba95d23d4d97",
            "completionRatio": 67.338715,
            "tunnelName": "河南祁连隧道"
        },
        {
            "tunnelNumber": "3ed7a31a9d314752901c353c1aa2b4cc",
            "completionRatio": 48.314606,
            "tunnelName": "青海峨眉隧道"
        },
        {
            "tunnelNumber": "f10a251162be4a299c38207c9e9c10dc",
            "completionRatio": 30.952381,
            "tunnelName": "青海华山隧道"
        },
        {
            "tunnelNumber": "0c1c58c2d2ee4c4e8661a3cff4fd8d41",
            "completionRatio": 41.616405,
            "tunnelName": "青海泰山隧道"
        },
        {
            "tunnelNumber": "a993db85998144d6aa7668b068d6042b",
            "completionRatio": 13.877551,
            "tunnelName": "青海黄山隧道"
        },
        {
            "tunnelNumber": "ca914e4a9427439db560f8e075f970b0",
            "completionRatio": 47.19562,
            "tunnelName": "青海白鹭隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 24.852072,
            "tunnelName": "湖南琥珀隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 5.56,
            "tunnelName": "李家山隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 12.1,
            "tunnelName": "天目山隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 11.76,
            "tunnelName": "岭上村隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 10.8,
            "tunnelName": "上田岭隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 9.6,
            "tunnelName": "黄山隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 3.44,
            "tunnelName": "葛亮山隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 10.66,
            "tunnelName": "新方斗山隧道"
        },
        {
            "tunnelNumber": "d6c55a6dcf4b448eb8487d6f4fdd7a74",
            "completionRatio": 10.4,
            "tunnelName": "佛照山隧道"
        }
    ]
}